import { ValidatorFn } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import type { SourceField } from '../../../../features/admin/modules/modules.model';
import { ibanValidator } from '../../../validators/iban';
import { phoneValidator } from '../../../validators/phone';

/** Format checks an admin can switch on for a plain `input` field (form builder "Validatie"). */
const INPUT_VALIDATORS: Record<Exclude<SourceField['inputValidation'], '' | undefined>, ValidatorFn> = {
  iban: ibanValidator,
  phone: phoneValidator,
};
const ALL_INPUT_VALIDATORS: unknown[] = Object.values(INPUT_VALIDATORS);

/**
 * Attaches the format check named in `props.inputValidation` to a plain input.
 *
 * Deliberately a prop rather than Formly's own `validators.validation: ['iban']` in the stored
 * form: Formly throws on a validator name it does not know, so a form saved with that shape would
 * break every build that predates the registration. An unknown prop is simply ignored.
 *
 * Replaces rather than appends, so a rebuild after the prop changed leaves exactly the current check.
 */
export function inputValidationExtension(field: FormlyFieldConfig): void {
  if (field.type !== 'input') {
    return;
  }
  const key = field.props?.['inputValidation'];
  const validator = Object.hasOwn(INPUT_VALIDATORS, key) ? INPUT_VALIDATORS[key] : undefined;
  const current = field.validators?.validation ?? [];
  const others = current.filter(v => !ALL_INPUT_VALIDATORS.includes(v));
  if (!validator && others.length === current.length) {
    return;
  }
  field.validators = { ...field.validators, validation: validator ? [...others, validator] : others };
}
